import { AtomVisual } from "../workspace/AtomVisual.js";

export function WelcomePanel() {
  return (
    <section className="welcome-panel" data-testid="chat-welcome">
      <AtomVisual />
      <h2>欢迎使用 Truth Seeker 科研助手</h2>
      <p>专注于科研领域的智能问答与分析，快速获取研究洞察与实验支持。</p>
    </section>
  );
}
